var render = function render(){
  var _vm$priceAdjustmentLi;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "price-adjustment"
  }, [_vm._m(0), _c('div', {
    staticClass: "flex items-end justify-between gap-5 mb-6 mdmax:flex-col mdmax:items-start"
  }, [_c('div', {
    staticClass: "flex items-end gap-5 mdmax:flex-col mdmax:items-start mdmax:gap-3 mdmax:w-full"
  }, [_c('div', {
    staticClass: "w-60 mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Status")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.statusOptions,
      "default": _vm.selectedStatus,
      "placeholder": "All Status"
    },
    on: {
      "change": _vm.handleFilterChange
    },
    model: {
      value: _vm.selectedStatus,
      callback: function ($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  })], 1), _c('div', {
    staticClass: "w-60 mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Rentang Tanggal")]), _c('div', {
    staticClass: "date-range relative text-xs"
  }, [_c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2 z-1"
  }, [_c('Calendar', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('date-range-picker', {
    attrs: {
      "locale-data": {
        format: 'dd/mm/yyyy',
        separator: ' - '
      },
      "showDropdowns": false,
      "timePicker": false,
      "timePicker24Hour": false,
      "ranges": false
    },
    on: {
      "update": _vm.handleDateRangeChange
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  })], 1)]), _c('div', {
    staticClass: "w-40 mdmax:flex-1"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Sort")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.sortOptions,
      "default": _vm.selectedSort
    },
    on: {
      "change": _vm.handleFilterChange
    },
    model: {
      value: _vm.selectedSort,
      callback: function ($$v) {
        _vm.selectedSort = $$v;
      },
      expression: "selectedSort"
    }
  })], 1)])]), _c('div', {}, [_c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.priceAdjustmentList,
      "compact": ""
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'order_id' ? _c('div', [_c('p', {
          staticClass: "font-medium"
        }, [_vm._v(_vm._s(entry.order_id))]), _c('p', {
          staticClass: "text-xs text-neutral-500"
        }, [_vm._v("ID: " + _vm._s(entry.id))])]) : column.field === 'old_details' ? _c('div', [_c('p', {
          staticClass: "text-sm"
        }, [_c('span', {
          staticClass: "font-medium"
        }, [_vm._v(_vm._s(entry.old_weight) + " kg")]), _c('span', {
          staticClass: "text-neutral-500 mx-1"
        }, [_vm._v("|")]), _c('span', {
          staticClass: "text-neutral-500"
        }, [_vm._v(_vm._s(entry.old_dimension))])]), _c('p', {
          staticClass: "text-sm font-semibold text-neutral-700 mt-1"
        }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(entry.old_price)) + " ")])]) : column.field === 'new_details' ? _c('div', [_c('p', {
          staticClass: "text-sm"
        }, [_c('span', {
          staticClass: "font-medium"
        }, [_vm._v(_vm._s(entry.new_weight) + " kg")]), _c('span', {
          staticClass: "text-neutral-500 mx-1"
        }, [_vm._v("|")]), _c('span', {
          staticClass: "text-neutral-500"
        }, [_vm._v(_vm._s(entry.new_dimension))])]), _c('p', {
          staticClass: "text-sm font-semibold text-neutral-700 mt-1"
        }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(entry.new_price)) + " ")])]) : column.field === 'difference' ? _c('div', [_c('p', {
          staticClass: "text-sm font-bold text-red-600"
        }, [_vm._v(" +" + _vm._s(_vm._f("currencyFormat")(entry.new_price - entry.old_price)) + " ")])]) : column.field === 'status' ? _c('div', [_c('span', {
          staticClass: "px-3 py-1 rounded-full text-xs font-medium inline-block",
          class: _vm.getStatusClass(entry.status)
        }, [_vm._v(" " + _vm._s(entry.status) + " ")])]) : column.field === 'created_at' ? _c('div', [_vm._v(" " + _vm._s(_vm._f("formatDate")(entry.created_at)) + " ")]) : column.field === 'action' ? _c('div', [entry.status === 'Payment Under Verification' ? _c('div', {
          staticClass: "flex gap-2"
        }, [_c('button', {
          staticClass: "px-3 py-1.5 bg-primary-600 text-white text-xs font-medium rounded-lg hover:bg-primary-700 transition-colors",
          on: {
            "click": function ($event) {
              return _vm.handleCompleteClick(entry.order_id);
            }
          }
        }, [_vm._v(" Complete ")]), _c('button', {
          staticClass: "px-3 py-1.5 bg-red-600 text-white text-xs font-medium rounded-lg hover:bg-red-700 transition-colors",
          on: {
            "click": function ($event) {
              return _vm.handleRejectClick(entry.order_id);
            }
          }
        }, [_vm._v(" Reject ")])]) : _c('span', {
          staticClass: "text-xs text-neutral-400"
        }, [_vm._v("-")])]) : _c('span', [_vm._v(_vm._s(entry[column.field] || "-"))])];
      }
    }])
  }), ((_vm$priceAdjustmentLi = _vm.priceAdjustmentList) === null || _vm$priceAdjustmentLi === void 0 ? void 0 : _vm$priceAdjustmentLi.length) > 0 ? [!_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords) + " ")]) : _vm._e(), _vm.priceAdjustmentList && _vm.priceAdjustmentList.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-end items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()] : !_vm.isLoading ? _c('div', {
    staticClass: "text-center py-12 text-neutral-500"
  }, [_c('p', {
    staticClass: "text-lg"
  }, [_vm._v("No price adjustments found")])]) : _vm._e()], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleConfirmModal,
      "width": "600px",
      "id": "confirmation-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleConfirmModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v("Complete Price Adjustment")]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" Are you sure you want to mark this price adjustment as \"Additional Payment Completed\"? This action cannot be undone. ")])])]), _c('div', {
    staticClass: "flex gap-4 justify-end"
  }, [_c('button', {
    staticClass: "px-4 py-2 border border-neutral-300 rounded-lg text-neutral-700 hover:bg-neutral-50 transition-colors",
    on: {
      "click": function ($event) {
        return _vm.toggleConfirmModal();
      }
    }
  }, [_vm._v(" Cancel ")]), _c('button', {
    staticClass: "px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors",
    on: {
      "click": function ($event) {
        return _vm.handleConfirmComplete();
      }
    }
  }, [_vm._v(" Confirm ")])])])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleRejectModal,
      "width": "600px",
      "id": "rejection-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleRejectModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v("Reject Price Adjustment")]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" Are you sure you want to reject this price adjustment? The status will be reverted to \"Pending Additional Payment\". ")])])]), _c('div', {
    staticClass: "flex gap-4 justify-end"
  }, [_c('button', {
    staticClass: "px-4 py-2 border border-neutral-300 rounded-lg text-neutral-700 hover:bg-neutral-50 transition-colors",
    on: {
      "click": function ($event) {
        return _vm.toggleRejectModal();
      }
    }
  }, [_vm._v(" Cancel ")]), _c('button', {
    staticClass: "px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors",
    on: {
      "click": function ($event) {
        return _vm.handleConfirmReject();
      }
    }
  }, [_vm._v(" Reject ")])])])], 2)], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-6"
  }, [_c('h1', {
    staticClass: "text-2xl font-bold text-neutral-800"
  }, [_vm._v("Price Adjustment")]), _c('p', {
    staticClass: "text-sm text-neutral-500 mt-1"
  }, [_vm._v(" Manage price adjustments for orders with discrepancies ")])]);

}]

export { render, staticRenderFns }